import { defineComponent, provide, createElementBlock, openBlock, normalizeClass, unref, renderSlot } from "vue";
import { cn } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
import { FORM_ITEM_INJECTION_KEY } from "../injectionKeys.js";
import { u as useId } from "../../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/shared/useId.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "FormItem",
  props: {
    class: {}
  },
  setup(__props) {
    const props = __props, id = useId();
    return provide(FORM_ITEM_INJECTION_KEY, id), (_ctx, _cache) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(unref(cn)("grid gap-2", props.class)),
      "data-slot": "form-item"
    }, [
      renderSlot(_ctx.$slots, "default")
    ], 2));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=FormItem.js.map
